<template>
    <div class="row">
        <div class="col-6">
            Trạng thái đăng tin:

            <b-form-select 
                v-model="status" 
                :options="options"  
                ></b-form-select>

            <b-button variant="primary" @click="submitStatus" v-if="status !== productInfo.posting_status">Cập nhật trạng thái</b-button>
        </div>
        <div class="col-6">
            Nhắc nhở sau 

             <b-form-input 
                v-model="reminder" 
                ></b-form-input>

            ngày

            <b-button variant="primary" @click="submitReminder" v-if="reminder !== productInfo.posting_reminder">Cập nhật trạng thái</b-button>
        </div>
    </div>
</template>

<script>

import ProductPostingService from './ProductPostingService';

export default {
  name: 'ProductPostingStatus',
  components: {
      
  },
  data () {
    return {
        status: '',
        reminder: 0,
        productInfo: {
            posting_status: '',
            posting_reminder: 0
        },

        options: [
            'Đang đăng tin',
            'Đã hoàn tất'
        ]
    }
  },
  watch: {
      productid: function(newVal, oldVal) { // watch it
        this.getPostingStatus();
      }
  },
  
  methods: {
      async getPostingStatus() {
          if(!this.productid)
            return;

        var service = new ProductPostingService();
        var info = await service.getProductStatus(this.productid);

        console.log('info ', info);

        if(info && info.posting_status) {
            this.productInfo.posting_status = info.posting_status;
            this.productInfo.posting_reminder = info.posting_reminder;

            this.status = info.posting_status;
            this.reminder = info.posting_reminder;
        } else {
            // alert('Không thể lấy được thông tin trạng thái đăng ký');
        }
      },

      async submitStatus () {
          var service = new ProductPostingService();
          service.updateProductStatus(this.productid, this.status);
          alert('Trạng thái đã được cập nhật');
      },

      async submitReminder () {
          var service = new ProductPostingService();
          service.updateProductColumn(this.productid, 'posting_reminder', this.reminder, 'number');
          alert('Trạng thái đã được cập nhật');
      }
  },
  props: [
    'productid'
  ],
  mounted () {
  }
}
</script>

<style scoped>
</style>
